import PropTypes from 'prop-types';
import { withSecureServicesData } from 'hoc/page.hoc';
import ModuleView from 'partial/OfferManager/ModuleView';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import { MODULE_NAME_OVERVIEW } from 'partial/OfferManager/container.constants';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const ContainerManager = ({ ...props }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  if (props.staticModules) {
    return (
      <div data-testid={`${props.datatestid}`}>
        <ModuleView
          actionState={props.actionState}
          cardComparisonAttributes={props.cardComparisonAttributes}
          cashAccount={props.cashAccount}
          config={props.config}
          creditInfo={props.creditInfo}
          defaultActiveKey={props.defaultActiveKey}
          dispatch={dispatch}
          eventHandler={props.eventHandler}
          extraAttributes={props.extraAttributes}
          history={history}
          isInvisibleUser={props.isInvisibleUser}
          isOcfPage={props.isOcfPage}
          isPersonalLoanCarousel={props.isPersonalLoanCarousel}
          moduleList={props.staticModules}
          moduleToShow={props.moduleToShow}
          moduleView={props.moduleView}
          myNumberActions={props.myNumberActions}
          onLinkClickCallback={props.onLinkClickCallback}
          onTabChange={props.onTabChange}
          onTabClick={props.onTabClick}
          optimizelyExperimentObj={props.optimizelyExperimentObj}
          partnersCustomTrackingMeta={props.partnersCustomTrackingMeta}
          selectedTab={props.selectedTab}
          userInfo={props.userInfo}
          isDefaultModuleViewDisabled={props?.isDefaultModuleViewDisabled}
          CustomModuleRepository={props?.CustomModuleRepository}
          gapClass={props?.gapClass}
          location={location}
        />
      </div>
    );
  } else {
    return (
      <>
        <div data-testid={`${props.datatestid}`}></div>
      </>
    );
  }
};

ContainerManager.propTypes = {
  containerName: PropTypes.string,
  eventHandler: PropTypes.func.isRequired,
  staticModules: PropTypes.object,
};

ContainerManager.defaultProps = {
  containerName: MODULE_NAME_OVERVIEW,
  loadingMask: <LoadingMask />,
};

const connectedContainerManager = withSecureServicesData(ContainerManager);

export default connectedContainerManager;
